function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { PureComponent } from 'react';
import { Checkbox } from '@nextiva/next-ui';
import TableHeader from "./TableHeader";

var DataTableHeader =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(DataTableHeader, _PureComponent);

  function DataTableHeader() {
    _classCallCheck(this, DataTableHeader);

    return _possibleConstructorReturn(this, (DataTableHeader.__proto__ || Object.getPrototypeOf(DataTableHeader)).apply(this, arguments));
  }

  _createClass(DataTableHeader, [{
    key: "renderCheckbox",
    value: function renderCheckbox() {
      var _props = this.props,
          handleSelectAllRows = _props.handleSelectAllRows,
          allRowsSelected = _props.allRowsSelected;
      return React.createElement("div", null, React.createElement(Checkbox, {
        onChange: handleSelectAllRows,
        checked: allRowsSelected,
        size: 16
      }));
    }
  }, {
    key: "renderControls",
    value: function renderControls() {
      var _props2 = this.props,
          controlsColumnWidth = _props2.controlsColumnWidth,
          checkable = _props2.checkable,
          multi = _props2.multi,
          disableSelectAll = _props2.disableSelectAll,
          children = _props2.children,
          hasData = _props2.hasData;
      var hasCheckbox = [checkable, multi, !disableSelectAll, children.length, hasData].every(function (v) {
        return !!v;
      });
      return React.createElement("th", {
        key: "controls",
        className: "nx-table__controls-header",
        width: controlsColumnWidth
      }, hasCheckbox && this.renderCheckbox());
    }
  }, {
    key: "renderHeaderColumns",
    value: function renderHeaderColumns() {
      var _props3 = this.props,
          resizable = _props3.resizable,
          handleResize = _props3.handleResize,
          handleResizeStop = _props3.handleResizeStop,
          drag = _props3.drag,
          handleDragStart = _props3.handleDragStart,
          columnWidths = _props3.columnWidths,
          displayPreferences = _props3.displayPreferences,
          headerRowHeight = _props3.headerRowHeight,
          children = _props3.children;
      return React.Children.toArray(children).filter(function (_ref) {
        var name = _ref.props.name;
        return !!columnWidths[name];
      }).map(function (child) {
        var name = child.props.name;
        var item = displayPreferences.find(function (item) {
          return item.name === name;
        });
        return React.cloneElement(child, {
          width: columnWidths[name].width,
          height: headerRowHeight,
          resizable: typeof item.resizable === 'undefined' ? resizable : item.resizable,
          isDragged: drag && drag.name === name,
          onResize: handleResize,
          onResizeStop: handleResizeStop,
          onDragStart: handleDragStart
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props4 = this.props,
          headerRenderer = _props4.headerRenderer,
          hasActions = _props4.hasActions,
          shouldRenderPreviewIcon = _props4.shouldRenderPreviewIcon,
          checkable = _props4.checkable,
          children = _props4.children,
          headerRowHeight = _props4.headerRowHeight;
      var hasCheckable = checkable && !!children.length;
      var header = headerRenderer([(hasCheckable || hasActions || shouldRenderPreviewIcon) && this.renderControls()].concat(_toConsumableArray(this.renderHeaderColumns()), [React.createElement("th", {
        key: "last"
      }, React.createElement("div", {
        style: {
          height: headerRowHeight
        }
      }))]));
      return React.createElement(TableHeader, null, header);
    }
  }]);

  return DataTableHeader;
}(PureComponent);

export { DataTableHeader as default };